import algoliasearch from "algoliasearch/lite"

import { defaultArea } from "@common/constant"
import { milesToMeter } from "@common/utils/property_utils"
import { result } from "lodash"

// const {
//   removeSpecialChar,
// } = require("@starberry/gatsby-library-common/BasicUtils")

/** string remove all special characters */
export const removeSpecialChar = (val, symbol = "-") => {
  if (val) {
    // return val
    // .replace(/[^\w\s]/gi, " ")
    // .replace(/\s\s+/g, " ")
    // .replace(/ /gi, symbol)
    // .toLowerCase()

    const replaceSplChr = val.replace(/[^\w\s]/gi, " ").replace(/\s\s+/g, " ")
    return replaceSplChr.trim().replace(/ /gi, symbol).toLowerCase()
  }
  return val.trim()
}

export const addTraillingSlash = (url) => {
  let newUrl = url

  if (url && url[url.length - 1] !== "/") {
    newUrl += "/"
  }
  return newUrl
}

// format URL using the search filters form values
export const createResultsUrl = (props) => {
  // lets form the URL

  let searchtypePath = ""
  let areaPath = ""
  let bedPath = ""
  let pricePath = ""
  let buildingPath = ""
  let sortPath = ""
  let departmentPath = "property"
  let layoutPath = ""
  let radiusPath = ""
  let excludePath = ""
  const sortValue = props?.sortVal || props?.sortby
  const searchtypeVal = props?.srchTypeVal || props.searchtypeVal

  // console.log("props ==>", props)

  if (props?.departmentVal === "commercial") {
    departmentPath = "commercial-property"
  } else if (props?.departmentVal === "newdevelopments") {
    departmentPath = "new-developments"
  } else if (props?.departmentVal === "newhomes") {
    departmentPath = "newhomes"
  }

  if (searchtypeVal === "buy" || searchtypeVal === "sales") {
    searchtypePath = "for-sale/"
  } else if (searchtypeVal === "rent" || searchtypeVal === "lettings") {
    searchtypePath = "to-rent/"
  } else {
    searchtypePath = "for-sale/"
  }

  // console.log("props_areaVal", removeSpecialChar(props?.areaVal))

  if (props?.areaVal) {
    areaPath = `in-${encodeURIComponent(
      decodeURIComponent(removeSpecialChar(props?.areaVal)),
    )}/`
  } else {
    areaPath = `in-${process.env.GATSBY_DEFAULT_AREA.toLowerCase()}/`
  }

  if (parseInt(props?.bedVal, 10) >= 0) {
    if (parseInt(props?.bedVal, 10) === 0) {
      bedPath = "studio/"
    }

    if (parseInt(props?.bedVal, 10) > 0) {
      if (props.bedValPlus === "false") {
        bedPath = `${props?.bedVal}-bedrooms/`
      } else {
        bedPath = `${props?.bedVal}-and-more-bedrooms/`
      }
    }
  }
  if (props?.minpriceVal || props?.maxpriceVal) {
    if (props?.minpriceVal && props?.maxpriceVal) {
      pricePath = `between-${props?.minpriceVal}-and-${props?.maxpriceVal}/`
    } else if (props?.maxpriceVal) {
      pricePath = `below-${props?.maxpriceVal}/`
    } else if (props?.minpriceVal) {
      pricePath = `above-${props?.minpriceVal}/`
    }
  }
  if (props?.buildingval) {
    buildingPath = `type-${props?.buildingval.replace(/ /g, "-")}/`
  }
  if (props?.areaVal) {
    if (props?.radiusVal) {
      radiusPath = `radius-${props?.radiusVal.replace(/ /g, "-")}/`
    }
  }
  if (props?.excludeVal) {
    excludePath = `exclude-${props?.excludeVal}/`
  }
  if (sortValue) {
    if (sortValue === `${process.env.GATSBY_ALGOLIA_INDEX_NAME}_price_asc`) {
      sortPath = "sortby-price-asc/"
    } else if (
      sortValue === `${process.env.GATSBY_ALGOLIA_INDEX_NAME}_newest`
    ) {
      sortPath = "sortby-newest/"
    } else if (
      sortValue === `${process.env.GATSBY_ALGOLIA_INDEX_NAME}_oldest`
    ) {
      sortPath = "sortby-oldest/"
    } else {
      sortPath = ""
    }
    // if (
    //   props?.sortby === `${process.env.GATSBY_ALGOLIA_INDEX_NAME}_price_desc`
    // ) {
    //   // sortPath = "sortby-price-desc/"
    //   sortPath = ""
    // }
  }
  if (props?.layout) {
    layoutPath = "map-view/"
  }
  let myUrl = `/${departmentPath}/${searchtypePath}${areaPath}${bedPath}${pricePath}${buildingPath}${radiusPath}${excludePath}${sortPath}${layoutPath}`

  myUrl = myUrl.toLowerCase().replace(/ /g, "-")

  return addTraillingSlash(myUrl)
}

export const parseResultsUrl = (
  location,
  basePath,
  searchType,
  departmentType,
  propertyStatus,
  indexNameVal,
) => {
  // split the URL
  if (location) {
    let pathUriMain = ""
    let departmentVal = "residential"
    let searchtypeVal = ""
    let areaVal = process.env.GATSBY_DEFAULT_AREA
      ? process.env.GATSBY_DEFAULT_AREA.toLowerCase()
      : ""
    let bedVal = ""
    let bedValPlus = "false"
    let minpriceVal = ""
    let maxpriceVal = ""
    let pageVal = "1"
    let buildingval = ""
    let sortVal = ""
    let layoutVal = ""
    let indexName = indexNameVal || process.env.GATSBY_ALGOLIA_INDEX_NAME
    let propertyTypeVal = "residential"
    let mustincludeVal = ""
    let furnishVal = ""
    let branchVal = ""
    let radiusVal = ""
    let excludeVal = ""

    const salespage = location.pathname.indexOf("/property/for-sale") > -1
    const lettingspage = location.pathname.indexOf("/property/to-rent") > -1
    const newDevelopments =
      location.pathname.indexOf("/new-developments/for-sale") > -1
    const commercialsalepage =
      location.pathname.indexOf("/commercial-property/for-sale") > -1
    const commercialrentpage =
      location.pathname.indexOf("/commercial-property/to-rent") > -1
    const newHomesPage = location.pathname.indexOf("/newhomes/for-sale") > -1

    if (basePath) {
      pathUriMain = location.pathname.split(basePath)
      searchtypeVal = searchType
      departmentVal = departmentType
    } else if (salespage === true) {
      pathUriMain = location.pathname.split("/property/for-sale")
      searchtypeVal = "sales"
    } else if (lettingspage === true) {
      pathUriMain = location.pathname.split("/property/to-rent")
      searchtypeVal = "lettings"
    } else if (newDevelopments === true) {
      pathUriMain = location.pathname.split("/new-developments/for-sale")
      searchtypeVal = "sales"
      indexName =
        process.env.GATSBY_ALGOLIA_NEW_DEVELOPMENTS_INDEX_NAME ||
        process.env.GATSBY_ALGOLIA_INDEX_NAME_NEW_DEVELOPMENT
      propertyTypeVal = "newdevelopments"
      departmentVal = "new-developments"
    } else if (commercialsalepage === true) {
      pathUriMain = location.pathname.split("/commercial-property/for-sale")
      searchtypeVal = "sales"
      departmentVal = "commercial"
    } else if (commercialrentpage === true) {
      pathUriMain = location.pathname.split("/commercial-property/to-rent")
      searchtypeVal = "lettings"
      departmentVal = "commercial"
    } else if (newHomesPage === true) {
      pathUriMain = location.pathname.split("/newhomes/for-sale")
      searchtypeVal = "sales"
      departmentVal = "newhomes"
    }

    if (pathUriMain[1]) {
      // following could be regexp
      const pathUri = pathUriMain[1].split("/")

      // console.log("pathUriMain", pathUri[0])

      // lets loop
      for (let vi = 0; vi <= pathUri.length; vi++) {
        // check for area
        if (typeof pathUri[vi] === "undefined") {
          continue
        }

        // Area
        if (pathUri[vi].indexOf("in-") >= 0) {
          areaVal = removeSpecialChar(pathUri[vi].replace("in-", ""), " ")
        }

        // Bedrooms
        if (pathUri[vi].indexOf("-bedrooms") >= 0) {
          bedVal = pathUri[vi].replace("-bedrooms", "")
          bedValPlus = "false"
        }

        if (pathUri[vi].indexOf("-and-more-bedrooms") >= 0) {
          bedVal = pathUri[vi].replace("-and-more-bedrooms", "")
          bedValPlus = "true"
        }
        if (pathUri[vi].indexOf("studio") >= 0) {
          bedVal = 0
        }

        // Property type
        if (pathUri[vi].indexOf("type-") >= 0) {
          buildingval = pathUri[vi].replace("type-", "")
        }

        // Price
        if (
          pathUri[vi].indexOf("between-") >= 0 ||
          pathUri[vi].indexOf("above-") >= 0 ||
          pathUri[vi].indexOf("below-") >= 0 ||
          pathUri[vi].indexOf("under-") >= 0 ||
          pathUri[vi].indexOf("over-") >= 0
        ) {
          const priceFilt1 = pathUri[vi].split("above-")
          if (priceFilt1[1]) {
            minpriceVal = priceFilt1[1]
          }
          const priceFilt2 = pathUri[vi].split("below-")
          if (priceFilt2[1]) {
            maxpriceVal = priceFilt2[1]
          }
          const priceFilt3 = pathUri[vi].split("between-")
          if (priceFilt3[1]) {
            const priceFilt4 = priceFilt3[1].split("-and-")
            minpriceVal = priceFilt4[0]
            maxpriceVal = priceFilt4[1]
          }
          const priceFilt4 = pathUri[vi].split("over-")
          if (priceFilt4[1]) {
            minpriceVal = priceFilt4[1]
          }
          const priceFilt5 = pathUri[vi].split("under-")
          if (priceFilt5[1]) {
            maxpriceVal = priceFilt5[1]
          }
        }

        // Sort by
        if (pathUri[vi].indexOf("sortby-") >= 0) {
          const sortValFilt = pathUri[vi].replace("sortby-", "")

          if (sortValFilt === "") {
            sortVal = indexName
          }

          if (sortValFilt === "price-asc") {
            sortVal = `${indexName}_price_asc`
          }

          // if (sortValFilt === "price-desc") {
          //   sortVal = `${indexName}_price_desc`
          // }
          if (sortValFilt === "price-desc") {
            sortVal = `${indexName}`
          }

          if (sortValFilt === "newest") {
            sortVal = `${indexName}_newest`
          }

          if (sortValFilt === "oldest") {
            sortVal = `${indexName}_oldest`
          }
        }

        // Page
        if (pathUri[vi].indexOf("page") >= 0) {
          pageVal = pathUri[vi].replace("page-", "")
        }

        if (pathUri[vi].indexOf("map-view") >= 0) {
          layoutVal = "map"
        }

        // Mustinclude
        if (pathUri[vi].indexOf("with-") >= 0) {
          // mustincludeVal = pathUri[vi].replace("with-", "")
          const mustincludeArrfilt = pathUri[vi].replace("with-", "")
          mustincludeVal = mustincludeArrfilt.split("-and-")
        }

        // Furnishing Val
        if (pathUri[vi].indexOf("furnishing-") >= 0) {
          furnishVal = pathUri[vi].replace("furnishing-", "")
        }

        // Branch Val
        if (pathUri[vi].indexOf("branch-") >= 0) {
          branchVal = pathUri[vi].replace("branch-", "")
        }

        if (pathUri[vi].indexOf("radius-") >= 0) {
          radiusVal = pathUri[vi]
            .replace("radius-", "")
            .replace("-miles", "")
            .replace("-mile", "")
        }

        // Include Val
        if (pathUri[vi].indexOf("exclude-") >= 0) {
          excludeVal = pathUri[vi].replace("exclude-", "")
        }
      }
    }

    const mydatarr = []
    mydatarr.indexVal = indexName
    mydatarr.departmentVal = departmentVal
    mydatarr.searchtypeVal = searchtypeVal
    mydatarr.areaVal = areaVal
    mydatarr.bedVal = bedVal
    mydatarr.bedValPlus = bedValPlus
    mydatarr.minpriceVal = minpriceVal
    mydatarr.maxpriceVal = maxpriceVal
    mydatarr.pageVal = pageVal
    mydatarr.buildingval = buildingval
    mydatarr.sortVal = sortVal
    mydatarr.layoutVal = layoutVal
    mydatarr.propertyTypeVal = propertyTypeVal
    mydatarr.mustincludeVal = mustincludeVal
    mydatarr.furnishVal = furnishVal
    mydatarr.branchVal = branchVal
    mydatarr.radiusVal = radiusVal
    mydatarr.excludeVal = excludeVal
    return mydatarr
  }
  return false
}

export const generateFiltersfromPageData = ({
  departmentVal,
  searchtypeVal,
  // areaVal,
  bedVal,
  bedValPlus,
  minpriceVal,
  maxpriceVal,
  buildingval,
  mustincludeVal,
  furnishVal,
  excludeVal,
  // radiusVal,
}) => {
  // lets from the filters
  // here the search login lives
  const myfilter = []

  // console.log("bedVal", bedVal)

  // facet filters
  if (departmentVal) {
    myfilter.push(`(department:${departmentVal})`)
  }
  if (searchtypeVal) {
    myfilter.push(
      `(searchType:${searchtypeVal}) OR (search_type:${searchtypeVal})`,
    )
  }

  // Include Sold / Let
  if (excludeVal === "sold" && searchtypeVal === "sales") {
    myfilter.push("(status:'For Sale')")
  } else if (excludeVal === "let" && searchtypeVal === "lettings") {
    myfilter.push("(status:'To Let')")
  } else if (searchtypeVal === "lettings") {
    myfilter.push(
      "(status:'To Let') OR (status:'Let Agreed') OR (status:'Let') OR (status:'Under Offer')",
    )
  } else {
    myfilter.push(
      "(status:'For Sale') OR (status:'Sale Agreed') OR (status:'Sold') OR (status:'Under Offer')",
    )
  }

  // if(areaVal && areaVal !== "london"){
  //     myfilter.push("(area:"+areaVal+" OR post_code:"+areaVal+" OR display_address:"+areaVal+")")
  // }
  if (buildingval) {
    if (buildingval === "fine-and-country") {
      myfilter.push("(is_fineAndCountry:true)")
    } else {
      myfilter.push(`(building:${buildingval})`)
    }
  }
  // numberic filters

  if (bedValPlus === "true") {
    if (parseInt(bedVal, 10) >= 0) {
      myfilter.push(`(bedroom >= ${bedVal})`)
    }
  } else if (parseInt(bedVal, 10) >= 0) {
    myfilter.push(`(bedroom = ${bedVal})`)
  }
  if (minpriceVal && minpriceVal > 0 && maxpriceVal && maxpriceVal > 0) {
    myfilter.push(`(price >= ${minpriceVal} AND price <= ${maxpriceVal})`)
  } else if (maxpriceVal && maxpriceVal > 0) {
    myfilter.push(`(price <= ${maxpriceVal})`)
  } else if (minpriceVal && minpriceVal > 0) {
    myfilter.push(`(price >= ${minpriceVal})`)
  }
  // if(pageVal){
  //     myfilter.push("(page: "+(pageVal)+")")
  // }
  myfilter.push("(publish: true)")

  // Mustinclude
  if (mustincludeVal?.length > 0) {
    // query += `&refinementList[mustInclude]=` + mustincludeVal
    for (let v = 0; v <= mustincludeVal.length; v++) {
      if (typeof mustincludeVal[v] !== "undefined") {
        myfilter.push(`(mustInclude:${mustincludeVal[v]})`)
      }
    }
  }

  if (furnishVal) {
    myfilter.push(`(furnishing:${furnishVal})`)
  }

  // if (radiusVal) {
  //   const latlng = "50.259998,-4.652498"
  //   myfilter.push(`(aroundRadius:${milesToMeter(radiusVal)})`)
  //   myfilter.push(`(aroundLatLng:${latlng})`)
  //   myfilter.push("(getRankingInfo:true)")
  // }

  return myfilter.join(" AND ")
}

export const getAlgoliaResults = (
  myalgoliafilters,
  pageUrlData,
  pageLimit,
  latLang,
  showMapView,
) => {
  const client = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_API_KEY,
  )
  const index = client.initIndex(
    pageUrlData.sortVal
      ? pageUrlData.sortVal
      : process.env.GATSBY_ALGOLIA_INDEX_NAME,
  )

  let filters = {
    filters: myalgoliafilters,
    page: showMapView ? 0 : pageUrlData.pageVal - 1,
    hitsPerPage: showMapView ? 9999 : pageLimit,
  }

  let areaVal =
    pageUrlData.areaVal === defaultArea.toLowerCase() ? "" : pageUrlData.areaVal

  if (parseInt(pageUrlData.radiusVal, 10) && latLang !== "all") {
    filters = {
      ...filters,
      aroundLatLng: latLang,
      aroundRadius: pageUrlData.radiusVal
        ? milesToMeter(pageUrlData.radiusVal)
        : "all",
    }
    areaVal = ""
  }

  return index.search(areaVal, filters)
}
